import { notFound } from 'next/navigation';

import { getChannel, getContent, getDocument, getVenueParamField } from '@lib/server';
import type { Aggregator, Place } from '@types';

export async function getBrandPlaceData(domain: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const brand = await getDocument<Aggregator>('brand', channel.micrositeData?.[0]?.id, {
    select: ['fields.venuesPageSlug', 'fields.name'],
    tags: [channel.channelId],
    depth: 0,
  });

  const places = await getContent<Place>('place')
    .setDepth(0)
    .setTags([channel.channelId])
    .setWhere([['sys.channels', 'contains', channel.id]])
    .fetch([
      'fields.default',
      'fields.name',
      'fields.apps',
      `fields.${getVenueParamField(channel)}`,
      'fields.custom.displayName',
      'id',
    ]);

  return {
    channel,
    venuesPageSlug: brand?.fields?.venuesPageSlug || 'bars',
    places: places?.map(({ id, fields }) => ({ id, ...fields })) as Place[],
    accessToken: channel.apps?.mapbox?.active ? channel.apps.mapbox.token : '',
  };
}
